<template>
    <div class="screen">
        <div v-for="line in lines" v-html="line" v-bind:style="{'font-size': preferences.fontScreenSize + 'px', 'font-weight': preferences.fontScreenBold ? 'bold' : 'normal', 'font-style': preferences.fontScreenItalic ? 'italic' : 'normal', 'font-family': preferences.fontScreenName, 'min-height': preferences.fontScreenSize + 'px'}"></div>
        <div v-show="readInputMode !== 'none'" class="input-wrapper" v-bind:style="{'font-size': preferences.fontScreenSize + 'px', 'font-weight': preferences.fontScreenBold ? 'bold' : 'normal', 'font-style': preferences.fontScreenItalic ? 'italic' : 'normal', 'font-family': preferences.fontScreenName, 'min-height': preferences.fontScreenSize + 'px'}">
            <div >&#62;</div>
            <input type="text" v-model="data"  ref="userinput" v-bind:style="{'font-size': preferences.fontScreenSize + 'px', 'font-weight': preferences.fontScreenBold ? 'bold' : 'normal', 'font-style': preferences.fontScreenItalic ? 'italic' : 'normal', 'font-family': preferences.fontScreenName, 'min-height': preferences.fontScreenSize + 'px'}" @keyup.enter="handleInput" @keydown="handleKey">
        </div>
    </div>
</template>

<script>
    import { EventBus } from './../../EventBus.js'
    import { Storage } from './../../Storage.js'

    export default {
        name: 'Screen',
        props: ['lines', 'readInputMode'],
        watch: {
            readInputMode (newValue, oldValue) {
                if (newValue !== 'none') {
                    this.$nextTick(() => {
                        this.$refs.userinput.focus()
                        this.$el.scrollTop = this.$el.scrollHeight
                    })
                }
            },
            lines () {
                this.$nextTick(() => {
                    this.$el.scrollTop = this.$el.scrollHeight
                })
            }
        },
        created () {

        },
        mounted () {
            EventBus.$on('config.preferences.changed', this.updatePrefernces)
            this.updatePrefernces()
        },
        methods: {
            handleKey () {
                if (this.readInputMode === 'key') {
                    this.$emit('read', this.data)
                    this.$nextTick(() => {
                        this.data = ''
                    })
                }
            },
            handleInput () {
                if (this.data !== '' || this.readInputMode === 'key') {
                    this.$emit('read', this.data)
                    this.data = ''
                }
            },
            updatePrefernces () {
                for (let prefName in this.preferences) {
                    this.preferences[prefName] = Storage.getPreference(prefName, this.preferences[prefName])
                }
            }
        },
        data () {
            return {
                data: '',
                preferences: {
                    fontScreenName: 'Inconsolata',
                    fontScreenSize: 16,
                    fontScreenBold: false,
                    fontScreenItalic: false
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .screen {
        width: calc(100% - 8px);
        height:  calc(100% - 28px);
        overflow-y: auto;
        overflow-x: hidden;
        background: #E8E8C9;
        color: #444;
        font-size: 16px;
        padding-left: 4px;
        padding-right: 4px;
        padding-top: 4px;
    }

    .input-wrapper {
        border: 0px;
        width: 100%;
        color: #444;
        position: relative;
        background-color: #DD9;
        display: flex;
    }
    .input-wrapper input {
        display: inline-block;
        border: 0px;
        width: 100%;
        color: #444;
        background: transparent;
    }
    .input-wrapper div {
        display: inline-block;
    }
</style>


// WEBPACK FOOTER //
// src/Components/CodeEditor/Screen.vue